import CardWrapper from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/CardWrapper';
import type {
  MentorProfileIndexCard,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';

import MentorButtons from './Buttons';

interface MentorCardProps {
  program: Program;
  mentorProfile: MentorProfileIndexCard;
  disabledAccess?: boolean;
}

const MentorCard = ({
  program,
  mentorProfile,
  disabledAccess,
}: MentorCardProps) => {
  const {
    config: {
      is_location_displayed_in_mentor_card: isLocationDisplayedInMentorCard,
      is_skills_displayed_in_mentor_card: isSkillsDisplayedInMentorCard,
    },
  } = program;

  return (
    <CardWrapper
      isSkillsDisplayed={isSkillsDisplayedInMentorCard}
      isLocationDisplayed={isLocationDisplayedInMentorCard}
      profile={mentorProfile}
      customAttributes={program.mentor_customizable_attributes.filter(
        ({ config }) => config?.is_displayed_in_mentoring_card,
      )}
    >
      <MentorButtons
        mentorProfile={mentorProfile}
        program={program}
        disabledAccess={disabledAccess}
      />
    </CardWrapper>
  );
};

export default MentorCard;
